// @flow
import * as React from 'react';
import { Heading, Box, Text } from 'grommet';
import { VALUE_COLOR } from 'esm-web-pro/components/layout/sidePanel/Attributes';

type Props = {
    text: String,
    textSize: String,
    marginBox: String,

}

const CustomTitle = (props: Props) => {
    const {
        text, textSize, marginBox,
    } = props;
    return (
        <div style={{ margin: marginBox }}>
            <Heading size={textSize} color={VALUE_COLOR}>
                {text}
            </Heading>
        </div>
    );
};

CustomTitle.defaultProps = {
    text: '',
    textSize: '16px',
    marginBox: 'auto',
};

export default CustomTitle;
